export default __webpack_public_path__ + "static/media/eb-ultra-wht-poster-3.2f79f8fa.jpg";